import React, { useContext, useEffect, useState } from "react";
import Footer from "../Footer/Footer";
import Backbutton from "../../assests/popup/backButton.svg";

import DeleteModel from "./DeleteModel";
import EditArea from "./EditArea";
import ProfileGrid from "./ProfileGrid";
import ProfileHead from "./ProfileHead";
import ProfileSettings from "./ProfileSettings";
import Banner from "../Banner";
import axios from "axios";
import Context from "../../context/Context";
import { useUserAuth } from "../../context/UserAuthContext";
// import ProfilePopup from './ProfilePopup'
import styles from "./Profile.module.css";
import { useNavigate, useParams } from "react-router";
import ContactUsFooter from "../ContactUsFooter/ContactUsFooter";
import FloatingWidgets from "../FloatingWidgets/FloatingWidgets";
import { isEmpty } from "lodash";
import { createSearchParams } from "react-router-dom";

function Profile() {
  const [editProfile, setEditProfile] = useState(false);
  const [settings, setSettings] = useState(true);
  const { currentUser, previousLocation, searchParams } = useUserAuth();
  const {
    updateData,
    userIdToken,
    preview,
    details,
    campaignDataFromLocal,
    isMobile,
  } = useContext(Context);
  const [data, setData] = useState({});
  const { organizerUniqueText, campaignUniqueText } = campaignDataFromLocal;
  const token = userIdToken || currentUser?.accessToken;

  useEffect(() => {
    loadDetails();
  }, [currentUser, updateData]);

  const loadDetails = async () => {
    try {
      let config = {
        method: "get",
        url: `${process.env.REACT_APP_GET_PROFILE_DETAILS}`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };
      const response = await axios(config);
      let dataFromApi = response?.data?.data;
      setData((prevState) => ({
        ...prevState,
        profilePicture: dataFromApi?.profilePicture,
        name: dataFromApi?.name,
        email: dataFromApi?.email,
        phone: dataFromApi?.phone,
        userId: dataFromApi?._id,
        phoneNumber: dataFromApi?.phoneNumber,
      }));
    } catch (error) {
      console.log(error.message);
      //navigate("/error")
    }
  };

  const navigate = useNavigate();
  const handleNavigate = () => {
    if (settings) {
      if (previousLocation) {
        if (preview) {
          navigate({
            pathname: previousLocation,
            search: "?preview=true",
          });
        } else {
          navigate({
            pathname: previousLocation,
            search: `${searchParams ? createSearchParams(searchParams) : ""}`,
          });
        }
      } else if (organizerUniqueText && campaignUniqueText) {
        navigate({
          pathname: `/${organizerUniqueText}/${campaignUniqueText}`,
          search: `${searchParams ? createSearchParams(searchParams) : ""}`,
        });
      } else {
        navigate({
          pathname: `/`,
          search: `${searchParams ? createSearchParams(searchParams) : ""}`,
        });
      }
    } else {
      setSettings(true);
    }
  };
  const profileHelpNavigate = () => {
    navigate("help");
  };
  return (
    <div className="widthController ">
      {/* <Banner/> */}
      <FloatingWidgets page="profile" endTime={details?.endDate} />

      <div className="bg-[#0B0B0B] relative z-10">
        {!editProfile && (
          <>
            <div className="min-h-[40px] flex w-[100%] items-center py-[12px] px-[20px] z-100 sticky top-0  left-0 z-10 header-bg gap-[12px] ">
              {/* {!isMobile && ( */}
              <img
                onClick={handleNavigate}
                className="h-[40px] w-[40px]  hover:cursor-pointer"
                src={Backbutton}
                alt=""
              />
              {/* )} */}

              <p className="text-regular ">Profile</p>
            </div>
            <ProfileHead
              setEditProfile={setEditProfile}
              setSettings={setSettings}
              settings={settings}
            />
            <div className="px-[20px]">
              <div className="seperator" />
            </div>
            <div className={styles.background}>
              <ProfileGrid data={data} />
              <div className="p-[20px]">
                <div className="seperator mb-[12px]" />
                <ProfileSettings setSettings={setSettings} />
              </div>
            </div>
          </>
        )}
        {/* {showPreview &&
                <ProfilePopup setShowPreview={setShowPreview} />
            } */}
        {editProfile && (
          <>
            <EditArea
              setEditProfile={setEditProfile}
              data={data}
              setData={setData}
            />
            <div className="p-[20px]">
              <div className="seperator mb-[12px]" />
              <ProfileSettings setSettings={setSettings} />
            </div>
          </>
        )}
      </div>
      <div className="px-[20px] pt-[40px]">
        <div className="seperator" />
      </div>
      <ContactUsFooter profileHelpNavigate={profileHelpNavigate} />
    </div>
  );
}

export default Profile;
